import { render, staticRenderFns } from "./TheSideBar.vue?vue&type=template&id=5dd5818f&"
import script from "./TheSideBar.vue?vue&type=script&lang=ts&"
export * from "./TheSideBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports